import cx from 'classnames';

export const OPTION_HEIGHT_TW_CLASS_NAME = 'h-12';

export const getCommonOptionStylesAsClassName =
  'border-none flex text-left w-full py-0 px-4 h-12 items-center justify-between bg-white';

export const getOptionStylesAsClassName = (
  selected: boolean,
  focused: boolean
): string => {
  return cx(getCommonOptionStylesAsClassName, {
    'bg-gray-xlight': focused,
    'text-primary-dark': selected,
    'text-primary-main': !selected,
  });
};

export const getOptionIconStylesAsClassName = 'float-right text-primary-main';
